*,
*::before,
*::after {
  box-sizing: border-box;
}

.ui-button {
  cursor: pointer;
  overflow: hidden;
  position: relative;
  text-align: center;
  user-select: none;
  display: inline-flex;
  justify-content: space-around;
  align-items: center;
  border: none;
  border-radius: var(--ui-border-radius-md);
  font-family: var(--ui-font-family);
  font-size: var(--ui-font-size-base);
  font-weight: var(--ui-font-weight-semi-bold);
  line-height: var(--ui-line-height-base);
  min-height: 48px;
  padding: 0 var(--ui-space-md);
  transition: background-color var(--ui-animation-duration) ease;
  text-decoration: none;
  letter-spacing: inherit;
}

.ui-button:focus-visible {
  outline: 2px solid var(--ui-color-focus);
  outline-offset: 2px;
}

.ui-button:focus:not(:focus-visible) {
  outline: none;
}

.ui-button--accent {
  background-color: var(--ui-color-primary);
  color: var(--ui-color-white);
}

@media (hover: hover) {
  .ui-button--accent:hover {
    background-color: var(--ui-color-primary-3);
    border-color: var(--ui-color-primary-3);
  }
}

.ui-button--secondary {
  background-color: var(--ui-color-secondary);
  color: var(--ui-color-text-contrast);
}

@media (hover: hover) {
  .ui-button--secondary:hover {
    background: var(--ui-color-gray-10);
  }
}

.ui-button--secondary-outlined {
  background-color: transparent;
  border: 1px solid currentcolor;
  color: var(--ui-color-text);
}

@media (hover: hover) {
  .ui-button--secondary-outlined:hover {
    color: var(--ui-color-gray-10);
  }
}

.ui-button--dark {
  background-color: var(--ui-color-dark);
  color: var(--ui-color-white);
}

@media (hover: hover) {
  .ui-button--dark:hover {
    background-color: color-mix(in srgb, var(--ui-color-dark) 70%, white);
  }
}

.ui-button--light {
  background-color: var(--ui-color-white);
  color: var(--ui-color-dark);
}

@media (hover: hover) {
  .ui-button--light:hover {
    background-color: color-mix(in srgb, var(--ui-color-white) 89%, black);
  }
}

.ui-button--light-outlined {
  background-color: transparent;
  border: 1px solid currentcolor;
  color: var(--ui-color-white);
}

@media (hover: hover) {
  .ui-button--light-outlined:hover {
    color: color-mix(in srgb, var(--ui-color-white) 89%, black);
  }
}

.ui-button--link {
  background-color: transparent;
  color: var(--custom-link-color, var(--ui-color-tertiary));
  text-decoration: underline;
  text-decoration-color: var(--custom-link-color, var(--ui-color-tertiary-alpha));
}

.ui-button--text {
  background-color: transparent;
  color: currentcolor;
  text-decoration: inherit;
}

.ui-button--mobile {
  cursor: default;
  -webkit-tap-highlight-color: transparent;
}

.ui-button--block {
  width: 100%;
  display: flex;
}

.ui-button--disabled {
  pointer-events: none;
  user-select: none;
  opacity: 0.5;
}

.ui-button--loading {
  cursor: wait;
  user-select: none;
}

.ui-button__loader {
  display: inline-block;
  height: 1lh;
}

.ui-button--custom-size {
  padding: var(--ui-button-padding, 0 var(--ui-space-md));
  min-height: var(--ui-button-height, 48px);
  font-size: var(--ui-button-font-size, 16px);
  font-weight: var(--ui-button-font-weight, var(--ui-font-weight-semi-bold));
  text-transform: var(--ui-button-text-transform, none);
}

.ui-button--text-like-size {
  padding: 0;
  min-height: 24px;
  font-size: inherit;
  font-weight: inherit;
}

@media (forced-colors: active) {
  .ui-button {
    border: 1px solid ButtonText;
    color: ButtonText;
  }

  .ui-button--secondary-outlined,
  .ui-button--light-outlined {
    border-width: 2px;
  }

  .ui-button--link {
    color: LinkText;
    border: none;
  }

  .ui-button--text {
    color: LinkText;
    border: none;
  }
}

.visually-hidden {
  position: absolute;
  clip-path: inset(50%);
  overflow: hidden;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  white-space: nowrap;
}
